<template>
<div>
  <div v-bind:style="substrateTop"></div>
  <div v-bind:style="substrateLeft"></div>
  <div v-bind:style="substrateAngle"></div>
<table>
  <thead ref="tableHead">
    <tr ref="tableUperHead">
      <th v-for="(item, index) in headers"
          @click="toggleHeaderCell(index);"
          class="headers"
          v-bind:style="headersCellStyle[index]"
          :rowspan="item.rowspan"
          :colspan="item.colspan">
        {{item.name}}
      </th>
    </tr>
    <tr>
      <th v-for="subheader in subheaders"
          v-bind:style="subheadersStyle">
        {{subheader}}
      </th>
    </tr>
  </thead>
  <tbody ref="tableBody">
      <template v-for="(row, index) in rows"> 
      <tr @click="toggle(row.id);" :class="{ opened: opened.includes(row.id) }">
        <th v-if="opened.includes(row.id) && row.sub_rows.length == 0"  v-bind:style="clickable">{{(index+1)}}</th>
        <th v-if="!opened.includes(row.id) && row.sub_rows.length == 0" v-bind:style="clickable">{{(index+1)}}</th>

        <th v-if="opened.includes(row.id) && row.sub_rows.length != 0" v-bind:style="clickable">{{clos_ + (index+1)}}</th>
        <th v-if="!opened.includes(row.id) && row.sub_rows.length != 0"  v-bind:style="clickable">{{open_ + (index+1)}}</th>

        <td v-for="(col, i) in columns"
            v-bind:style="columnsStyles[i]">
          {{row[col]}}
        </td>
      </tr>
      <tr v-if="opened.includes(row.id)" v-for="(subrow, subindex) in row.sub_rows" >
          <th>{{(index+1) + '.' + (subindex+1)}}</th>
        <td v-for="(col, i) in columns"
            v-bind:style="columnsStyles[i]">
          {{subrow[col]}}
        </td>
      </tr>
    </template>
  </tbody>
</table>
</div>
</template>

<script>

export default {
  name: 'simpleDT',
  props: ['dataset'],
  watch: {
    dataset(newDataset){
      this.rows = newDataset.rows
      this.headers = newDataset.headers
      this.subheaders = newDataset.subheaders
      this.defaultSubheaders = newDataset.subheaders
      this.columns = newDataset.columns
      this.defaultColumns = newDataset.columns
      this.columnsStyles = newDataset.columnsStyles
      this.headersCellStyle = newDataset.headersCellStyle
      this.deafaultheadersCellStyle = newDataset.headersCellStyle
    }
  },
  data: function() {
    return {
    open_: '>  ',
    clos_: '<  ',
    width: 0,
    rows: '',
    headers: '',
    subheaders: '',
    defaultSubheaders: '',
    columns: '',
    defaultColumns: '',
    columnsStyles: '',
    headersCellStyle: '',
    deafaultheadersCellStyle: '',
    opened: [],
    isToggled: false,
    substrateTop: {
        position: 'fixed', /* for Safari */
        zIndex: 7,
        top: '10% + 125px',
        backgroundColor: 'black',
        borderWidth: '0px',
        width: '1200px',
        height: '69px'
      },
    substrateLeft: {
        position: 'fixed', /* for Safari */
        zIndex: 6,
        top: '10% + 300px',
        backgroundColor: 'black',
        borderWidth: '2px',
        width: '98px',
        height: '400px'
      },
    substrateAngle: {
        position: 'fixed', /* for Safari */
        zIndex: 9,
        top: '10% + 1px',
        backgroundColor: 'black',
        borderWidth: '2px',
        width: '98px',
        height: '60px'
      },
    subheadersStyle: {
        position: '-webkit-sticky', /* for Safari */
        position: 'sticky',
        zIndex: 8,
        top: '53.1px',
        background: '#4d82cb',
        color: '#FFF',
    },
    clickable: {
        cursor: 'pointer'
      },
    interval: '',
    interval_1: ''
    }
  },
  methods: {
    toggle(id) {
      const index = this.opened.indexOf(id);

      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened.push(id)
      }
    },
    toggleHeaderCell(index) {
      if (index == 3 && !this.isToggled) {
        //console.log(index)
        this.headersCellStyle[3].width = '300px'
        this.subheaders = this.defaultSubheaders
        this.headers[3].colspan = 3
        this.headers[3].rowspan = 1
        this.columns = ["name", "2018", "2019", "2019", "2019"]
        this.isToggled = true
      }
      else if (index == 3 && this.isToggled) {
        //console.log('HEU')
        this.headersCellStyle[3].width = '100px'
        this.subheaders = []
        this.headers[3].colspan = 1
        this.headers[3].rowspan = 2
        this.columns = ["name", "2018", "2019"]
        this.isToggled = false
      }
    },
    handleResize() {
      this.substrateTop.width = (window.innerWidth - 20) + 'px';

      if(typeof this.$refs.tableHead !== 'undefined') {
        let headHeight = this.$refs.tableHead.clientHeight
        let headWidth = this.$refs.tableHead.clientWidth
        let tableUperHeadHieght = this.$refs.tableUperHead.clientHeight
        //console.log('tableUperHeadHieght. ', tableUperHeadHieght)
        this.subheadersStyle.top = tableUperHeadHieght + 'px'
        this.substrateTop.width = (headWidth + 2) + 'px';
        this.substrateTop.height = (headHeight + 2) + 'px'
        this.substrateAngle.height = (headHeight + 2) + 'px'
      }
      if(typeof this.$refs.tableBody !== 'undefined') {
        let headHeight = this.$refs.tableHead.clientHeight
        let bodyHeight = this.$refs.tableBody.clientHeight
        this.substrateLeft.height = (bodyHeight + headHeight) + 'px'
        let firstColumnWidth = this.$refs.tableBody.children[0].children[0].clientWidth
        this.substrateLeft.width = (firstColumnWidth + 5) + 'px'
        this.substrateAngle.width = (firstColumnWidth + 5) + 'px'
      }
    },
    toLocaleString(num) {
      return num.toLocaleString()
    },
    //handleChanges() {
    //  this.$forceUpdate()
    //},
  },
  mounted() {
    //console.log(this.dataset)

    this.rows = this.dataset.rows
    this.headers = this.dataset.headers
    this.subheaders = this.dataset.subheaders
    this.defaultSubheaders = this.dataset.subheaders
    this.columns = this.dataset.columns
    this.defaultColumns = this.dataset.columns
    this.columnsStyles = this.dataset.columnsStyles
    this.headersCellStyle = this.dataset.headersCellStyle
    this.deafaultheadersCellStyle = this.dataset.headersCellStyle

    if(this.rows[0].sub_rows.length == 0) {
      this.clos_ = ''
      this.open_ = ''
      this.clickable = 'auto'
    }
    
    this.substrateTop.width = (window.innerWidth - 20) + 'px';

    if(typeof this.$refs.tableHead !== 'undefined') {
      let headHeight = this.$refs.tableHead.clientHeight
      let tableUperHeadHieght = this.$refs.tableUperHead.clientHeight
      //console.log('tableUperHeadHieght. ', tableUperHeadHieght)
      this.subheadersStyle.top = tableUperHeadHieght + 'px'
      this.substrateTop.height = (headHeight + 2) + 'px'
      this.substrateAngle.height = (headHeight + 2) + 'px'
    }
    if(typeof this.$refs.tableBody !== 'undefined') {
      let bodyHeight = this.$refs.tableBody.clientHeight
      this.substrateLeft.height = (bodyHeight) + 'px'
      let firstColumnWidth = this.$refs.tableBody.children[0].children[0].clientWidth
      //console.log(firstColumnWidth)
      this.substrateLeft.width = (firstColumnWidth + 5) + 'px'
      this.substrateAngle.width = (firstColumnWidth + 5) + 'px'
    }

    setTimeout(function () { this.handleResize() }.bind(this), 1000)
  },

  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
    this.interval = setInterval(() => this.handleResize(), 10);
    //this.interval_1 = setInterval(() => this.handleChanges(), 1000);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style>

div {
  width: 100%;
  max-height: 480px;
  overflow: scroll;
  position: relative;
}

table {
  position: relative;
  font-size: 12px;
  table-layout: fixed;
  border-collapse: collapse;
  background-color: white;
}

td, th {
  padding: 0.25em;
  border: 1px solid black;
}

th,
td {
  padding: 10px;
}

.headers {
  position: -webkit-sticky; /* for Safari */
  position: sticky;
  z-index: 8;
  top: 0px;
  background: #4d82cb;
  border-bottom: 1px solid black;
  color: #FFF;
}

.clickable {
  cursor: pointer;
}

thead th:nth-child(1) {
  position: -webkit-sticky; /* for Safari */
  position: sticky;
  width: 50px;
  z-index: 6;
  left: 0;
  background: #4d82cb;
  color: #FFF;
}

tbody th {
  position: -webkit-sticky; /* for Safari */
  position: sticky;
  width: 50px;
  z-index: 6;
  left: 0;
  background: #4d82cb;
  color: #FFF;
}
</style>
